// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

import React from "react";
import ExecutionActionRow from "./ExecutionActionRow";
import ExecutionStatusBadge from "./ExecutionStatusBadge";

const cardStyle = { border: "1px solid rgba(96, 165, 250, 0.24)", borderRadius: 16, padding: 16, background: "rgba(15, 23, 42, 0.42)", display: "grid", gap: 12 };

function displayValue(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return String(value);
  if (Array.isArray(value)) {
    const text = value.map((item) => displayValue(item, "")).filter(Boolean).join(", ");
    return text || fallback;
  }
  if (typeof value === "object") {
    const candidate = value.label || value.title || value.name || value.value || value.status || value.state || value.id;
    if (candidate !== undefined && candidate !== null && candidate !== value) return displayValue(candidate, fallback);
    try {
      return JSON.stringify(value);
    } catch (error) {
      return fallback;
    }
  }
  return String(value);
}

export default function ExecutionContextCard({ title, chips = [], dueLabel, meta = [], context, contextLabel = "Context", actions = [] }) {
  const safeChips = Array.isArray(chips) ? chips.filter(Boolean) : [];
  const safeMeta = Array.isArray(meta) ? meta.filter(Boolean) : [];
  return (
    <article style={cardStyle}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          {safeChips.map((chip, index) => (
            <ExecutionStatusBadge key={`${displayValue(chip.label, "chip")}-${chip.tone || "default"}-${index}`} tone={chip.tone || "default"}>{chip.label}</ExecutionStatusBadge>
          ))}
        </div>
        {dueLabel ? <strong style={{ color: "#bfdbfe", fontSize: 12 }}>{displayValue(dueLabel, "")}</strong> : null}
      </div>
      <h4 style={{ margin: 0, color: "#f8fafc", fontSize: 18, lineHeight: 1.25, wordBreak: "break-word" }}>{displayValue(title, "Selected task")}</h4>
      {safeMeta.length > 0 ? (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 10, color: "#bfdbfe", fontSize: 13 }}>
          {safeMeta.map((item, index) => (
            <div key={`${displayValue(item.label, "meta")}-${index}`} style={{ overflowWrap: item.wrap ? "anywhere" : "normal", minWidth: 0 }}>
              <strong style={{ color: "#f8fafc" }}>{displayValue(item.label, "Field")}:</strong> {displayValue(item.value)}
            </div>
          ))}
        </div>
      ) : null}
      {context ? <p style={{ color: "#bfdbfe", fontSize: 13, lineHeight: 1.55, margin: 0, wordBreak: "break-word" }}><strong style={{ color: "#f8fafc" }}>{displayValue(contextLabel, "Context")}:</strong> {displayValue(context, "")}</p> : null}
      <ExecutionActionRow actions={actions} />
    </article>
  );
}
